module.exports = __webpack_public_path__ + "static/media/img_0317.e86f94aa.jpeg";